import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, BookOpen } from "lucide-react";

const LINKS = [
  { to: "/complement-de-revenu", label: "Complément de revenu : le guide complet", lead: true },
  { to: "/complement-de-revenu-en-ligne", label: "Gagner un complément de revenu en ligne" },
  { to: "/activite-a-domicile", label: "Une activité à domicile, à votre rythme" },
  { to: "/arrondir-ses-fins-de-mois", label: "Arrondir ses fins de mois : idées concrètes" },
  { to: "/complement-de-revenu-sans-investissement", label: "Démarrer avec un petit budget" },
];

export const ResourcesTeaser = () => (
  <section
    id="ressources"
    data-testid="home-resources"
    className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto py-16 md:py-24 scroll-mt-20"
  >
    <div className="flex items-center gap-2 mb-3">
      <BookOpen className="w-5 h-5 text-[var(--oz-gold)]" />
      <span className="text-xs font-semibold uppercase tracking-[0.18em] text-[var(--oz-gold)]">
        Guides & ressources
      </span>
    </div>
    <h2 className="font-serif text-3xl sm:text-4xl text-[var(--oz-text)] max-w-2xl leading-tight">
      Tout savoir pour se créer un complément de revenu
    </h2>
    <p className="mt-3 text-base text-[var(--oz-muted)] max-w-2xl">
      Nos guides pratiques pour comprendre, choisir et développer une activité qui complète vos
      revenus — à votre rythme, sans promesse de gains.
    </p>

    <div className="mt-8 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
      {LINKS.map((l) => (
        <Link
          key={l.to}
          to={l.to}
          data-testid={`home-resource-${l.to.replace(/\//g, "")}`}
          className={`group flex items-center justify-between gap-3 rounded-2xl border px-5 py-4 transition-colors ${
            l.lead
              ? "sm:col-span-2 lg:col-span-1 bg-[var(--oz-dark)] text-white border-[var(--oz-dark)]"
              : "bg-white border-[var(--oz-border)] hover:border-[var(--oz-gold)]"
          }`}
        >
          <span className={`font-semibold ${l.lead ? "text-white" : "text-[var(--oz-text)]"}`}>
            {l.label}
          </span>
          <ArrowRight className={`w-4 h-4 flex-shrink-0 ${l.lead ? "text-[var(--oz-gold)]" : "text-[var(--oz-gold)] group-hover:translate-x-0.5 transition-transform"}`} />
        </Link>
      ))}
    </div>
  </section>
);
